<form
  class="dlg"
  role="dialog"
  aria-modal="true"
  aria-labelledby="dlg-title"
  [formGroup]="form"
  (ngSubmit)="save()"
>
  <header class="dlg__header">
    <h2 id="dlg-title" class="dlg__title">
      {{
        "service_manager.failed.modal.title"
          | translate : { default: " Cancelar servicio" }
      }}
    </h2>
    <p class="dlg__subtitle">
      {{
        "service_manager.failed.modal.description"
          | translate
            : { default: " Elige el motivo de cancelación para confirmarlo." }
      }}
    </p>
  </header>

  <section class="dlg__section">
    <label class="dlg__label" for="reason">
      {{
        "service_manager.failed.modal.reason"
          | translate : { default: "Motivo" }
      }}
    </label>

    <ng-select
      id="reasonId"
      [items]="reasons"
      groupBy="category"
      bindLabel="code"
      bindValue="id"
      [clearable]="false"
      [searchable]="false"
      placeholder="{{
        'service_manager.failed.modal.reason_placeholder'
          | translate 
      }}"
      formControlName="reasonId"
      class="reason-select"
    >
      <ng-template ng-option-tmp let-item="item">
        {{ "service_manager.failed.reasons." + item.code | translate }}
      </ng-template>

      <ng-template ng-optgroup-tmp let-item="item">
        <div class="item-group">
          {{ "service_manager.failed.categories." + item.category | translate }}
        </div>
      </ng-template>

      <ng-template ng-label-tmp let-item="item">
        {{ "service_manager.failed.reasons." + item.code | translate }}
      </ng-template>
    </ng-select>
  </section>

  <section
    class="dlg__section"
    *ngIf="otherReasonGuid && form.get('reasonId')?.value === otherReasonGuid"
  >
    <label class="dlg__label" for="reasonText">
      {{
        "service_manager.failed.modal.write_reason_title"
          | translate 
      }}
    </label>

    <textarea
      id="reasonText"
      class="input_form textarea_reason"
      formControlName="reasonText"
      rows="4"
      placeholder="{{
        'service_manager.failed.modal.write_reason_placeholder'
          | translate 
      }}"
    ></textarea>
  </section>

  <footer class="dlg__footer">
    <button type="button" class="btn btn--ghost" (click)="close()">
      {{ "common.actions.close" | translate : { default: "Cerrar" } }}
    </button>

    <button
      type="submit"
      class="btn btn--confirm"
      [disabled]="form.invalid || saving || reasonsLoading"
    >
      <ng-container *ngIf="saving; else saveLbl">
        <span class="spinner"></span>
      </ng-container>
      <ng-template #saveLbl>
        {{ "common.actions.confirm" | translate : { default: "Confirmar" } }}
      </ng-template>
    </button>
  </footer>
</form>
